'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyProducts: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.products')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/new-product-illustration.svg"
      variant="base"
    />
  )
}
